module.exports = __webpack_public_path__ + "static/medal-miwc-gold2020-8dc25cbd64294a77ab8de796a82fb59f.png";